import { render, staticRenderFns } from "./file-card.vue?vue&type=template&id=0adc9b71&scoped=true&"
import script from "./file-card.vue?vue&type=script&lang=js&"
export * from "./file-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc9b71",
  null
  
)

export default component.exports